import { render, staticRenderFns } from "./booksRecommend.vue?vue&type=template&id=117e811a&scoped=true&"
import script from "./booksRecommend.vue?vue&type=script&lang=js&"
export * from "./booksRecommend.vue?vue&type=script&lang=js&"
import style0 from "./booksRecommend.vue?vue&type=style&index=0&id=117e811a&lang=stylus&scoped=true&"
import style1 from "./booksRecommend.vue?vue&type=style&index=1&id=117e811a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117e811a",
  null
  
)

component.options.__file = "booksRecommend.vue"
export default component.exports